import { render } from "./Index.vue?vue&type=template&id=6dc87546"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6dc87546&lang=scss"
script.render = render

export default script